import { render, staticRenderFns } from "./jzpolicy.vue?vue&type=template&id=c4ae4f26&scoped=true"
import script from "./jzpolicy.vue?vue&type=script&lang=js"
export * from "./jzpolicy.vue?vue&type=script&lang=js"
import style0 from "./jzpolicy.vue?vue&type=style&index=0&id=c4ae4f26&prod&scoped=true&lang=less"
import style1 from "./jzpolicy.vue?vue&type=style&index=1&id=c4ae4f26&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ae4f26",
  null
  
)

export default component.exports